var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgError = function SvgError(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "#E16158",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("path", {
    strokeWidth: 1.5,
    d: "m5.332 4.71 5.039-2.346a3.86 3.86 0 0 1 3.275 0l5.019 2.337a4.05 4.05 0 0 1 2.328 3.9c-.395 6.44-2.152 9.353-6.903 12.731a3.575 3.575 0 0 1-4.162 0C5.19 17.972 3.368 15.1 3.006 8.577A4.04 4.04 0 0 1 5.332 4.71Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E16158",
    fillRule: "evenodd",
    strokeWidth: 0.4,
    d: "M11 17a1 1 0 1 1 2 0 1 1 0 0 1-2 0Zm.25-3a.75.75 0 0 0 1.5 0V7a.75.75 0 0 0-1.5 0z",
    clipRule: "evenodd"
  }))));
};
export default SvgError;